<template>
    <!-- Новий дизайн: «Випадкова піца», як у застосунку (екран RandomPizza): кидок кубика, далі піца
         з жартівливим текстом із поля custom_text. Піци беремо з уже завантаженого меню — без запиту /get-pizza -->
    <div class="bp-rnd" role="dialog" aria-modal="true" aria-labelledby="bp-rnd-title" @keydown.esc="$emit('close')">
        <div class="bp-rnd__overlay" @click="$emit('close')"></div>
        <div class="bp-rnd__box" ref="box" tabindex="-1">
            <button type="button" class="bp-rnd__x" aria-label="Закрити" @click="$emit('close')" v-html="icons.close"></button>
            <div class="bp-rnd__stage">
                <!-- Кубик падає згори (toss) і перекидається (cube) окремими шарами; приземляється логотипом догори.
                     Напрям перекиду — --rx/--ry, щоразу інший -->
                <div v-if="spinning" class="bp-dice" :key="roll.n" :style="{ '--rx': roll.rx, '--ry': roll.ry }" aria-hidden="true">
                    <span class="bp-dice__shadow"></span>
                    <div class="bp-dice__toss"><div class="bp-dice__tilt"><div class="bp-dice__cube">
                        <span v-for="face in faces" :key="face.n" :class="'bp-dice__f bp-dice__f--' + face.n">
                            <img v-if="face.logo" :src="logo" alt="" class="bp-dice__logo">
                            <i v-else v-for="cell in face.pips" :key="cell" :style="{ gridRow: Math.ceil(cell / 3), gridColumn: (cell - 1) % 3 + 1 }"></i>
                        </span>
                    </div></div></div>
                </div>
                <img v-else :src="photo(shown)" :alt="shown.title" class="bp-rnd__img" :class="{ 'bp-nophoto': noPhoto(shown) }">
            </div>
            <p class="bp-rnd__kicker" id="bp-rnd-title" v-if="spinning" aria-live="polite">Кидаємо кубик…</p>
            <template v-else>
                <p class="bp-rnd__kicker">Випадкова піца</p>
                <h2 class="bp-rnd__title" id="bp-rnd-title" v-html="shown.title"></h2>
                <p class="bp-rnd__text" v-if="shown.custom_text">{{ shown.custom_text }}</p>
                <p class="bp-rnd__desc"><span class="bp-rnd__w" v-if="shown.weight_30 > 0">{{ shown.weight_30 }} г – </span>{{ shown.description }}</p>
                <div class="bp-rnd__btns">
                    <button type="button" class="bp-rnd__again" @click="spin()"><span class="bp-rnd__ic" v-html="icons.dice"></span>Ще раз</button>
                    <button type="button" class="bp-rnd__order" ref="order" @click="$emit('order', shown)">Замовити від {{ price(shown) }} грн</button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'

const PIZZA_MOCK = (process.env.BASE_URL || '/') + 'img/pizza-nophoto.webp';
const isMock = pizza => /placeholder/i.test(pizza.thumbnail || '');
// Падіння з відскоками триває 1,4 с (bp-dice-toss у v2.css), піца з'являється одразу після приземлення
const TOSS_MS = 1400;
// Грані: клітинки 3×3 з крапками; замість «одиниці» — логотип
const FACES = [
    { n: 1, logo: true },
    { n: 2, pips: [1, 9] },
    { n: 3, pips: [1, 5, 9] },
    { n: 4, pips: [1, 3, 7, 9] },
    { n: 5, pips: [1, 3, 5, 7, 9] },
    { n: 6, pips: [1, 3, 4, 6, 7, 9] }
];

export default {
    name: 'BpRandomPizza',
    props: {
        pizzas: { type: Array, required: true }
    },
    data() {
        return {
            icons: ICONS,
            shown: this.pizzas[0],
            spinning: false,
            timer: null,
            faces: FACES,
            logo: require('@/assets/logo_site_mob.webp'),
            roll: { n: 0, rx: '0deg', ry: '0deg' }
        }
    },
    mounted() {
        document.querySelector('body').style.overflow = 'hidden';
        this.$refs.box.focus();
        this.spin();
    },
    beforeDestroy() {
        clearTimeout(this.timer);
        document.querySelector('body').style.overflow = '';
    },
    methods: {
        photo(pizza) {
            return isMock(pizza) ? PIZZA_MOCK : pizza.thumbnail;
        },
        noPhoto(pizza) {
            return isMock(pizza);
        },
        price(pizza) {
            return pizza.show_30 == 0 && pizza.price_50 ? pizza.price_50 : pizza.price_30;
        },
        pick(except) {
            const pool = this.pizzas.length > 1 ? this.pizzas.filter(pizza => pizza !== except) : this.pizzas;
            return pool[Math.floor(Math.random() * pool.length)];
        },
        spin() {
            clearTimeout(this.timer);
            const target = this.pick(this.spinning ? null : this.shown);
            const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduce) {
                this.shown = target;
                this.spinning = false;
                return;
            }
            // Логотип (передня грань) стає догори: rotateX на 90° плюс цілі оберти; rotateY — лише цілі оберти,
            // напрям перекиду щоразу випадковий
            const sign = () => (Math.random() < .5 ? -1 : 1);
            this.roll = { n: this.roll.n + 1, rx: (90 + sign() * 720) + 'deg', ry: (sign() * 360) + 'deg' };
            this.spinning = true;
            this.timer = setTimeout(() => {
                this.shown = target;
                this.spinning = false;
                this.$nextTick(() => this.$refs.order && this.$refs.order.focus({ preventScroll: true }));
            }, TOSS_MS + 150);
        }
    }
}
</script>
